import { gql } from "urql";
export const CreatePublicUnifiedPriorityEntryMutation = gql `
    mutation CreatePublicUnifiedPriorityEntry(
        $key1: String!
        $key2: String!
        $input: UnifiedPriorityEntryInput!
    ) {
        priorityEntries {
            createPublicUnifiedPriorityEntry(
                key1: $key1
                key2: $key2
                input: $input
            ) {
                success
            }
        }
    }
`;
